module.exports = __webpack_public_path__ + "static/media/campaignImageDemo.72d4c43b.png";